import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { languages } from './locales/languages'

const resources = Object.fromEntries(languages.map(({ code, translations }) => [code, { translation: translations }]))

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        supportedLngs: languages.map((l) => l.code),
        nonExplicitSupportedLngs: true,
        fallbackLng: 'en',
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
    })

export default i18n
